import React from 'react';
import {observer} from 'mobx-react';
import {Operator} from '../../Searches/consts/operators';
import {changeIgnoreCase} from '../actions/filters';
import {formsStore} from '../../Form/stores/FormsStore';
import {FilterBox} from '../../Searches/components/FilterBox';
import {Button, CheckBox, Flex, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {ColumnZoomType, ColumnType} from 'priority-web-sdk/enums';

export const FilterDropdownContent = observer(({filter, onSaveSearch, clearAlltags, search}) => {
    const approveBtnRef = React.useRef<HTMLButtonElement>(null);
    const {column, operator} = filter;
    const showIgnoreCaseCheckbox =
        column.type === ColumnType.Text &&
        ((operator !== Operator.Equals && operator !== Operator.NotEquals) ||
            (column.zoom !== ColumnZoomType.Choose && column.zoom !== ColumnZoomType.Search)) &&
        operator !== Operator.Empty &&
        operator !== Operator.NotEmpty;

    const onClose = () => {
        approveBtnRef?.current?.focus();
    };

    const toggleIgnoreCase = () => {
        changeIgnoreCase(formsStore?.searchesStore?.formSelected, filter);
    };

    return (
        <React.Fragment>
            <FilterBox
                filter={filter}
                label={false}
                sort={false}
                close={false}
                alwaysFocusOnMount
                onClose={onClose}
            />
            {showIgnoreCaseCheckbox && (
                <CheckBox
                    componentClasses={'filter-ckeckbox'}
                    onChange={toggleIgnoreCase}
                    checked={search?.ignoreCase}
                >
                    <Text skin="label-2" textColor={'secondary-400'}>
                        {getLocalizedText(texts.caseSensitive)}
                    </Text>
                </CheckBox>
            )}
            <Flex componentClasses="filter-footer-buttons" justifyContent={'flex-end'}>
                <Button
                    skin="text"
                    componentClasses="filter-footer-link-button"
                    disabled={filter.isEmpty}
                    prefixIcon={PriorityIcon.clear}
                    onClick={clearAlltags}
                >
                    {getLocalizedText(texts.clearSearch)}
                </Button>
                <Button
                    disabled={!filter.isDirty}
                    size="medium"
                    width="regularFixed"
                    onClick={onSaveSearch}
                    componentClasses="ignore-react-onclickoutside"
                    inputRef={approveBtnRef}
                >
                    {getLocalizedText(texts.apply)}
                </Button>
            </Flex>
        </React.Fragment>
    );
});
